// extracted by css-extract-rspack-plugin
export default {"AddSectionButton":"AddSectionButton-module__AddSectionButton___XcIoY"};